import { type Environment, type EnvironmentVariables, getEnvironmentVariables } from "#configs/environment.ts";
import { createContext, type PropsWithChildren, use } from "react";

interface Context {
    environmentVariables: EnvironmentVariables;
}

const Context = createContext<Context>({
    environmentVariables: {
        aiApiBaseUrl: "",
        navigationApiBaseUrl: "",
        managementAppBaseUrl: "",
        wlAppBaseUrl: "",
        cdnBaseUrl: "",
        navigationBarEnvironment: "production",
        loginPageUrl: "",
        intercomAppId: ""
    }
});

interface Props {
    environment: Environment;
}

export const EnvironmentProvider = ({ children, environment }: PropsWithChildren<Props>) => {
    const environmentVariables = getEnvironmentVariables(environment);

    return (
        <Context value={{ environmentVariables }}>
            {children}
        </Context>
    );
};

export const useEnvironmentVariables = () => {
    const context = use(Context);
    if (!context) {
        throw new Error("useEnvironmentVariables must be used within an EnvironmentProvider");
    }

    return context.environmentVariables;
};
